import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";

// Components
import Home from "../components/layouts/home";
import SEO from "../components/seo/seo";
import HeroCarousel from "../components/hero-carousel/hero-carousel";
import ThreeCards from "../components/three-cards/link-cards";
import ServiceStates from "../components/service-states/service-states";
import BestBanks from "../components/best-banks/best-banks";
import Button from "../components/custom-widgets/button";
import VideoModal from "../components/video-modal/video-modal";

import styles from "../pages/home-page.module.scss";

// Heplers
import getHeroImgVariables from "../helpers/getHeroImgVariables";

const IndexPage = () => {
  const imgData = useStaticQuery(graphql`
    {
      imgVariable1XXL: file(relativePath: { eq: "hero/carousel/home/carousel-sounders-credit-card-01-2500.jpg" }) {
        ...carouselHeroFragmentXL
      }
      imgVariable1XL: file(relativePath: { eq: "hero/carousel/home/carousel-sounders-credit-card-01-1920.jpg" }) {
        ...carouselHeroFragmentXL
      }
      imgVariable1LG: file(relativePath: { eq: "hero/carousel/home/carousel-sounders-credit-card-01-1200.jpg" }) {
        ...carouselHeroFragmentXL
      }
      imgVariable1MD: file(relativePath: { eq: "hero/carousel/home/carousel-sounders-credit-card-01-992.jpg" }) {
        ...carouselHeroFragmentXL
      }
      imgVariable1SM: file(relativePath: { eq: "hero/carousel/home/carousel-sounders-credit-card-01-768.jpg" }) {
        ...carouselHeroFragmentXL
      }
      imgVariable2XXL: file(relativePath: { eq: "hero/carousel/home/carousel-instant-open-02-2500.jpg" }) {
        ...carouselHeroFragmentXXL
      }
      imgVariable2XL: file(relativePath: { eq: "hero/carousel/home/carousel-instant-open-02-1920.jpg" }) {
        ...carouselHeroFragmentXL
      }
      imgVariable2LG: file(relativePath: { eq: "hero/carousel/home/carousel-instant-open-02-1200.jpg" }) {
        ...carouselHeroFragmentLG
      }
      imgVariable2MD: file(relativePath: { eq: "hero/carousel/home/carousel-instant-open-02-992.jpg" }) {
        ...carouselHeroFragmentMD
      }
      imgVariable2SM: file(relativePath: { eq: "hero/carousel/home/carousel-instant-open-02-768.jpg" }) {
        ...carouselHeroFragmentSM
      }
      card1: file(relativePath: { eq: "cards/card-wholesale-checking-01-600.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            quality: 100
            width: 600
            transformOptions: { cropFocus: CENTER }
            layout: CONSTRAINED
          )
        }
      }
      card2: file(relativePath: { eq: "cards/card-free-checking-05-600.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            quality: 100
            width: 600
            transformOptions: { cropFocus: CENTER }
            layout: CONSTRAINED
          )
        }
      }
      card3: file(relativePath: { eq: "cards/card-savings-01-600.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            quality: 100
            width: 600
            transformOptions: { cropFocus: CENTER }
            layout: CONSTRAINED
          )
        }
      }
    }
  `);
  //console.log("imgData: ", imgData);

  const [showSoundersVideo, setShowSoundersVideo] = useState(false);
  const closeSoundersVideo = () => setShowSoundersVideo(false);

  const heroSizes = ["sm", "md", "lg", "xl", "xxl"];
  const carouselData = {
    hasLogin: true,
    carouselDisplayClass: "d-none d-sm-block",
    slides: [
      {
        id: "home-hero-carousel-slide-1",
        ...getHeroImgVariables(imgData, heroSizes, 1),
        altText: "A woman holding WaFd Bank Cash Back Credit Card and smiling",
        caption: "Score Team Gear With Your New Sounders Credit Card!",
        heroBody: {
          colClass: "col-sm-12 col-md-7 col-lg-5 col-xl-4",
          components: [
            {
              id: 1,
              heading: {
                class: "text-white",
                text: "Score Team Gear With Your New Sounders Credit Card!"
              }
            },
            {
              id: 2,
              button: {
                id: "hero-btn-credit-cards",
                type: "link",
                class: "btn-primary mb-3",
                text: "Learn More",
                showIcon: true,
                url: "/personal-banking/credit-cards"
              }
            },
            {
              id: 3,
              button: {
                id: "hero-btn-credit-cards",
                type: "button",
                class: "btn-secondary mb-3",
                text: "Watch Video",
                showIcon: true,
                icon: {
                  name: "play",
                  class: "float-right mt-1 ml-3"
                },
                onClick: (e) => setShowSoundersVideo(true)
              }
            }
          ]
        }
      },
      {
        id: "home-hero-carousel-slide-2",
        ...getHeroImgVariables(imgData, heroSizes, 2),
        altText: "A man opening a checking account on his laptop.",
        caption: "Need to open a checking or savings account? It's fast and easy. We'll walk you through it.",
        heroBody: {
          colClass: "col-sm-12 col-md-8 col-lg-7 col-xl-5",
          components: [
            {
              id: 1,
              heading: {
                text: "Need to open a checking or savings account? It's fast and easy. We'll walk you through it."
              }
            },
            {
              id: 2,
              button: {
                id: "hero-btn-open-personal",
                type: "link",
                class: "btn-primary",
                text: "Open an Account",
                url: "/open-bank-account-online"
              }
            }
          ]
        }
      }
    ]
  };

  // TODO: convert to defaultProps
  const threeCardsData = {
    sectionClass: "my-5",
    hasRiseShadowEffect: true,
    cards: [
      {
        id: "link-card-cares",
        url: "/personal-banking/home-loans/closing-cost-checking-account-offer",
        title: "Save on Closing Costs",
        text: "Save Up to $600 on Mortgage Closing Costs With a Checking Account From WaFd Bank",
        image: {
          imgFixed: false,
          imgVariable: imgData.card1.childImageSharp.gatsbyImageData,
          altText: "A mother and her kids dancing in their living room"
        },
        button: {
          id: "link-card-cares-button",
          containerClass: "mt-auto w-100",
          type: "link",
          class: "btn-primary btn-block",
          text: "Learn More",
          showIcon: false,
          url: "/personal-banking/home-loans/closing-cost-checking-account-offer"
        }
      },
      {
        id: "link-card-mortgage",
        url: "/personal-banking/free-checking-account",
        title: "Free Checking still Exists!",
        text: "Truly Free Checking that helped us earn a Best Bank rating by Money.com",
        image: {
          imgFixed: false,
          imgVariable: imgData.card2.childImageSharp.gatsbyImageData,
          altText: "A smiling couple at home using online banking on a tablet"
        },
        button: {
          id: "link-card-mortgage-button",
          containerClass: "mt-auto w-100",
          type: "link",
          class: "btn-primary btn-block",
          text: "Learn More",
          showIcon: false,
          url: "/personal-banking/free-checking-account"
        }
      },
      {
        id: "link-card-refi",
        url: "/personal-banking/savings-account#certificates-of-deposit",
        title: "CD Special",
        text: "13-Month CD Special",
        image: {
          imgFixed: false,
          imgVariable: imgData.card3.childImageSharp.gatsbyImageData,
          altText: "A young family saving coins in a piggy bank"
        },
        button: {
          id: "link-card-refi-button",
          containerClass: "mt-auto w-100",
          type: "link",
          class: "btn-primary btn-block",
          text: "Learn More",
          showIcon: false,
          url: "/personal-banking/savings-account#savings-overview-section"
        }
      }
    ]
  };

  const SEOData = {
    title: "Bank Accounts, Home Loans, and Commercial Financing",
    alternate: [
      {
        rel: "alternate",
        href: "https://www.wafdbank.com",
        hreflang: "en-us"
      },
      {
        rel: "alternate",
        href: "https://www.wafdbank.com/es",
        hreflang: "es-us"
      }
    ],
    meta: [
      {
        name: "title",
        property: "og:title",
        content: "WaFd Bank"
      },
      {
        name: "description",
        property: "og:description",
        content:
          "Washington Federal, now known as WaFd Bank, offers  services including checking and savings accounts, mortgages, HELOC, construction and lot loans."
      },
      {
        name: "google-site-verification",
        content: "_mFadtR6nMvgpFsiuNrksFw-FqJ9tQ1MMSNbp6-8XtE"
      },
      {
        property: "og:url",
        content: "https://www.wafdbank.com"
      },
      {
        property: "og:type",
        content: "website"
      },
      {
        property: "og:site_name",
        content: "wafdbank"
      },
      {
        name: "application-name",
        content: "WaFd Bank public website"
      }
    ]
  };

  const bestBanksData = {
    columnClass: "col-md-7 col-lg-8 border-md-left",
    imageColumnClass: "col-md-5 col-lg-4",
    components: [
      <h2>Awarded America’s Best Big Bank by Newsweek – Two Years in a Row</h2>,
      <div className="d-none d-sm-block">
        <p className="text-larger">
          Best Bank winners were selected from over 2500 financial institutions and assessed on more than 30 factors,
          including overall health of the bank, customer service performance and features, digital and branch presence,
          account and loan options, and interest rate offerings and fees.
        </p>
        <p className="text-larger">Best Big Bank in Washington, Oregon, Idaho, and New Mexico</p>
        <a
          href="https://www.newsweek.com/americas-best-banks-2022/best-big-banks-state"
          target="_blank"
          rel="noopener noreferrer"
        >
          Newsweek Best Big Banks 2022
        </a>
      </div>
    ]
  };

  return (
    <Home>
      <SEO {...SEOData} />
      <HeroCarousel {...carouselData} />
      <VideoModal
        show={showSoundersVideo}
        handleClose={closeSoundersVideo}
        {...{
          id: "sounders-video-modal",
          VimeoID: "573096648",
          Title: "Sounders Fan Frenzy Ad"
        }}
      />
      {/* Replacement to the Carousel in mobile devices */}
      <section className="container d-sm-none bg-success">
        <h2 className="text-white">Score Team Gear With Your New Sounders Credit Card!</h2>
        <Button
          id="m-credit-cards-cta"
          type="link"
          class="w-100 btn-link mt-3 text-center"
          text="Learn More"
          url="/personal-banking/credit-cards"
          showIcon={false}
        />
      </section>
      <BestBanks {...bestBanksData} />
      <section className={`bg-light ${styles.constructionBgIcon}`} id="construction-banner">
        <div className="container text-center my-3">
          <h2>
            WaFd Bank’s All-in-One Construction Loan is one loan that covers both the building of your house and
            mortgage!
          </h2>
          <Button
            id="construction-learn-more-cta"
            containerClass="d-inline-block m-2"
            class="btn-link"
            url="/blog/home-ownership/construction-to-permanent-loans-explained"
            text="Learn More"
            showIcon={false}
          />
          <Button
            id="construction-loan-cta"
            containerClass="d-inline-block m-2"
            url="/personal-banking/home-loans/construction-loans"
            text="Apply Today"
            showIcon={false}
          />
        </div>
      </section>

      <ThreeCards {...threeCardsData} />
      <ServiceStates />
    </Home>
  );
};

export default IndexPage;
